type ValidateClientNameResult = {
  errors: string[];
  isValid: boolean;
};

const validateClientName = (name: string, originalName?: string): ValidateClientNameResult => {
  const errors: string[] = [];

  if (!name.trim()) {
    errors.push('Name is required');
  }

  if (name.length < 2) {
    errors.push('Name must be at least 2 characters');
  }

  if (name.length > 50) {
    errors.push('Name must not exceed 50 characters');
  }

  const isValid = errors.length === 0;
  const hasChanges = name !== originalName;

  return {
    errors,
    isValid: isValid && hasChanges,
  };
};

export { validateClientName };
